import { useLanguage } from "@/context/LanguageContext";

const Diamond = () => (
  <svg viewBox="0 0 20 20" className="h-4 w-4 shrink-0" aria-hidden="true">
    <defs>
      <linearGradient id="marq-rb" x1="0" y1="0" x2="20" y2="20" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#FF6B6B" />
        <stop offset="0.5" stopColor="#4ECDC4" />
        <stop offset="1" stopColor="#45B7D1" />
      </linearGradient>
    </defs>
    <path d="M10 1l3 9-3 9-3-9z" fill="url(#marq-rb)" transform="rotate(45 10 10)" />
  </svg>
);

const Marquee = () => {
  const { t } = useLanguage();
  const items = t.marquee.items;

  return (
    <div className="overflow-hidden border-y border-black/[0.06] bg-white/50 py-8 md:py-10" data-testid="marquee">
      <div className="marquee-track flex w-max items-center">
        {items.map((text, i) => (
          <span key={i} className="flex items-center gap-10 pr-10 md:gap-14 md:pr-14" aria-hidden={false}>
            <span className="whitespace-nowrap font-display text-4xl font-medium italic text-[#1A1A1A]/85 md:text-6xl">
              {text}
            </span>
            <Diamond />
          </span>
        ))}
        {items.map((text, i) => (
          <span key={`dup-${i}`} className="flex items-center gap-10 pr-10 md:gap-14 md:pr-14" aria-hidden="true">
            <span className="whitespace-nowrap font-display text-4xl font-medium italic text-[#1A1A1A]/85 md:text-6xl">
              {text}
            </span>
            <Diamond />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
